export const animationMillis = 400;